export default class Statistics {
    constructor() {
        this.levels = ["Easy", "Medium", "Hard", "CrazyNinja", "InsaneMonkey", "Impossible", "Online", "Bronze", "Silver", "Gold", "Platinum", "Diamond", "Master", "GrandMaster"];
        this.categoriesWithLevels = {
            gamesPlayed: "Matches Played",
            win: "Wins",
            win_rate: "Wins Rate",
            win_rate_dealer: "Wins Rate Start as Dealer",
            win_rate_pone: "Wins Rate Start as Pone",
            win_streak: "Win Streak",
            win_streak_max: "Win Streak Max",
            loss_streak: "Loss Streak",
            gamesPlayed_dealer: "Start As Dealer",
            gamesPlayed_pone: "Start As Pone",
            skunked: "Skunked",
            loss: "Loss",
            round_Played: "Rounds Played",
            round_Points_max: "Max Round Points",
            round_Points_max_dealer: "Max Round Points as Dealer",
            round_Points_max_pone: "Max Round Points as Pone",
            round_Points_avg: "Avg Round Points",
            roundOpponent_Points_avg: "Avg Round Points (Opponent)",
            round_Points_avg_dealer: "Avg Round Points as Dealer",
            roundOpponent_Points_avg_pone: "Avg Round Points as Dealer (Opponent)",
            round_Points_avg_pone: "Avg Round Points as Pone",
            roundOpponent_Points_avg_dealer: "Avg Round Points as Pone (Opponent)",
            pegging_Points_max: "Max Pegging Points",
            pegging_Points_max_dealer: "Max Pegging Points as Dealer",
            pegging_Points_max_pone: "Max Pegging Points as Pone",
            pegging_Points_avg: "Avg Pegging Points",
            peggingOpponent_Points_avg: "Avg Pegging Points (Opponent)",
            pegging_Points_avg_dealer: "Avg Pegging Points as Dealer",
            peggingOpponent_Points_avg_pone: "Avg Pegging Points as Dealer (Opponent)",
            pegging_Points_avg_pone: "Avg Pegging Points as Pone",
            peggingOpponent_Points_avg_dealer: "Avg Pegging Points as Pone (Opponent)",
            hand_Points_max: "Max Hand Points",
            hand_Points_max_dealer: "Max Hand Points as Dealer",
            hand_Points_max_pone: "Max Hand Points as Pone",
            hand_Points_avg: "Avg Hand Points",
            handOpponent_Points_avg: "Avg Hand Points (Opponent)",
            hand_Points_avg_dealer: "Avg Hand Points as Dealer",
            handOpponent_Points_avg_pone: "Avg Hand Points as Dealer (Opponent)",
            hand_Points_avg_pone: "Avg Hand Points as Pone",
            handOpponent_Points_avg_dealer: "Avg Hand Points as Pone (Opponent)",
            crib_Points_max: "Max Crib Points",
            crib_Points_avg: "Avg Crib Points",
            cribOpponent_Points_avg: "Avg Crib Points (Opponent)",
            hand_Analyzer_Score_avg: "Avg Hand Analyzer Score",
            hand_AnalyzerOpponent_Score_avg: "Avg Hand Analyzer Score (Opponent)",
            hand_PointsCount_percent_0to7: "0-7 Hand Percent",
            hand_PointsCount_percent_8to15: "8-15 Hand Percent",
            hand_PointsCount_percent_16to29: "16-29  Hand Percent",
            handOpponent_PointsCount_percent_0to7: "0-7 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_8to15: "8-15 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_16to29: "16-29 Hand Percent (Opponent)",
            hand_PointsCount_percent_0: "0 Hand Percent",
            hand_PointsCount_percent_1: "1 Hand Percent",
            hand_PointsCount_percent_2: "2 Hand Percent",
            hand_PointsCount_percent_3: "3 Hand Percent",
            hand_PointsCount_percent_4: "4 Hand Percent",
            hand_PointsCount_percent_5: "5 Hand Percent",
            hand_PointsCount_percent_6: "6 Hand Percent",
            hand_PointsCount_percent_7: "7 Hand Percent",
            hand_PointsCount_percent_8: "8 Hand Percent",
            hand_PointsCount_percent_9: "9 Hand Percent",
            hand_PointsCount_percent_10: "10 Hand Percent",
            hand_PointsCount_percent_11: "11 Hand Percent",
            hand_PointsCount_percent_12: "12 Hand Percent",
            hand_PointsCount_percent_13: "13 Hand Percent",
            hand_PointsCount_percent_14: "14 Hand Percent",
            hand_PointsCount_percent_15: "15 Hand Percent",
            hand_PointsCount_percent_16: "16 Hand Percent",
            hand_PointsCount_percent_17: "17 Hand Percent",
            hand_PointsCount_percent_18: "18 Hand Percent",
            hand_PointsCount_percent_19: "19 Hand Percent",
            hand_PointsCount_percent_20: "20 Hand Percent",
            hand_PointsCount_percent_21: "21 Hand Percent",
            hand_PointsCount_percent_22: "22 Hand Percent",
            hand_PointsCount_percent_23: "23 Hand Percent",
            hand_PointsCount_percent_24: "24 Hand Percent",
            hand_PointsCount_percent_25: "25 Hand Percent",
            hand_PointsCount_percent_26: "26 Hand Percent",
            hand_PointsCount_percent_27: "27 Hand Percent",
            hand_PointsCount_percent_28: "28 Hand Percent",
            hand_PointsCount_percent_29: "29 Hand Percent",
            handOpponent_PointsCount_percent_0: "0 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_1: "1 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_2: "2 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_3: "3 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_4: "4 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_5: "5 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_6: "6 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_7: "7 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_8: "8 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_9: "9 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_10: "10 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_11: "11 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_12: "12 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_13: "13 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_14: "14 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_15: "15 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_16: "16 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_17: "17 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_18: "18 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_19: "19 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_20: "20 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_21: "21 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_22: "22 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_23: "23 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_24: "24 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_25: "25 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_26: "26 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_27: "27 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_28: "28 Hand Percent (Opponent)",
            handOpponent_PointsCount_percent_29: "29 Hand Percent (Opponent)",
            hand_PointsCount_all: "All Hand Count",
            hand_PointsCount_0: "0 Hand Count",
            hand_PointsCount_1: "1 Hand Count",
            hand_PointsCount_2: "2 Hand Count",
            hand_PointsCount_3: "3 Hand Count",
            hand_PointsCount_4: "4 Hand Count",
            hand_PointsCount_5: "5 Hand Count",
            hand_PointsCount_6: "6 Hand Count",
            hand_PointsCount_7: "7 Hand Count",
            hand_PointsCount_8: "8 Hand Count",
            hand_PointsCount_9: "9 Hand Count",
            hand_PointsCount_10: "10 Hand Count",
            hand_PointsCount_11: "11 Hand Count",
            hand_PointsCount_12: "12 Hand Count",
            hand_PointsCount_13: "13 Hand Count",
            hand_PointsCount_14: "14 Hand Count",
            hand_PointsCount_15: "15 Hand Count",
            hand_PointsCount_16: "16 Hand Count",
            hand_PointsCount_17: "17 Hand Count",
            hand_PointsCount_18: "18 Hand Count",
            hand_PointsCount_19: "19 Hand Count",
            hand_PointsCount_20: "20 Hand Count",
            hand_PointsCount_21: "21 Hand Count",
            hand_PointsCount_22: "22 Hand Count",
            hand_PointsCount_23: "23 Hand Count",
            hand_PointsCount_24: "24 Hand Count",
            hand_PointsCount_25: "25 Hand Count",
            hand_PointsCount_26: "26 Hand Count",
            hand_PointsCount_27: "27 Hand Count",
            hand_PointsCount_28: "28 Hand Count",
            hand_PointsCount_29: "29 Hand Count",
        };
    }

    updateRoundStats(stats, cribbage, tablePosition) {
        if (!stats) stats = {};
        tablePosition = tablePosition || "player1";
        let opponent = tablePosition == "player1" ? cribbage.player2 : cribbage.player1;

        let level = cribbage.level;
        if (level === "Online" && opponent && opponent.rank) {
            //get opponet player's rank
            level = opponent.rank;
        }
        let scoreSummary = cribbage.roundSummary();

        let round = cribbage.roundNumber;
        let score = scoreSummary["player1"];
        let scoreOpponent = scoreSummary["player2"];
        if (tablePosition === "player2") {
            score = scoreSummary["player2"];
            scoreOpponent = scoreSummary["player1"];
        }
        let isDealer = score.isDealer;
        let dealerOrPone = isDealer ? "dealer" : "pone";
        let starter = score.starter || 0;
        let play = score.play + score.starter || 0;
        let playOpponent = scoreOpponent.play + scoreOpponent.starter || 0;
        let hand = score.hand || 0;
        let handOpponent = scoreOpponent.hand || 0;
        let crib = score.crib || 0;
        let cribOpponent = scoreOpponent.crib || 0;
        let roundTotal = score.total || 0;
        let roundTotalOpponent = scoreOpponent.total || 0;
        let analyzerScore = score.analyzerScore;
        let analyzerScoreOpponent = scoreOpponent.analyzerScore;
        let preHand = score.preHand;


        //get rounds played
        stats.round_Played = (stats.round_Played || 0) + 1;
        stats["round_Played_" + level] = (stats["round_Played_" + level] || 0) + 1;
        stats["round_Played_" + dealerOrPone + "_" + level] = (stats["round_Played_" + dealerOrPone + "_" + level] || 0) + 1;

        //get rounds Opponent played
        stats.roundOpponent_Played = (stats.roundOpponent_Played || 0) + 1;
        stats["roundOpponent_Played_" + level] = (stats["roundOpponent_Played_" + level] || 0) + 1;
        stats["roundOpponent_Played_" + dealerOrPone + "_" + level] = (stats["roundOpponent_Played_" + dealerOrPone + "_" + level] || 0) + 1;

        //get round points
        stats.round_Points = (stats.round_Points || 0) + roundTotal;
        stats["round_Points_" + level] = (stats["round_Points_" + level] || 0) + roundTotal;
        stats["round_Points_" + dealerOrPone + "_" + level] = (stats["round_Points_" + dealerOrPone + "_" + level] || 0) + roundTotal;

        //get round Opponent points
        stats.roundOpponent_Points = (stats.roundOpponent_Points || 0) + roundTotalOpponent;
        stats["roundOpponent_Points_" + level] = (stats["roundOpponent_Points_" + level] || 0) + roundTotalOpponent;
        stats["roundOpponent_Points_" + dealerOrPone + "_" + level] = (stats["roundOpponent_Points_" + dealerOrPone + "_" + level] || 0) + roundTotalOpponent;

        //get avg round points
        stats.round_Points_avg = this.round((stats.round_Points || 0) / (stats.round_Played || 1), 2);
        stats["round_Points_avg_" + level] = this.round((stats["round_Points_" + level] || 0) / (stats["round_Played_" + level] || 1), 2);
        stats["round_Points_avg_" + dealerOrPone + "_" + level] = this.round((stats["round_Points_" + dealerOrPone + "_" + level] || 0) / (stats["round_Played_" + dealerOrPone + "_" + level] || 1), 2);
        stats["round_Points_avg_" + dealerOrPone] = this.round((stats["round_Points_" + dealerOrPone] || 0) / (stats["round_Played_" + dealerOrPone] || 1), 2);

        //get avg round Opponent points
        stats.roundOpponent_Points_avg = this.round((stats.roundOpponent_Points || 0) / (stats.roundOpponent_Played || 1), 2);
        stats["roundOpponent_Points_avg_" + level] = this.round((stats["roundOpponent_Points_" + level] || 0) / (stats["roundOpponent_Played_" + level] || 1), 2);
        stats["roundOpponent_Points_avg_" + dealerOrPone + "_" + level] = this.round((stats["roundOpponent_Points_" + dealerOrPone + "_" + level] || 0) / (stats["roundOpponent_Played_" + dealerOrPone + "_" + level] || 1), 2);
        stats["roundOpponent_Points_avg_" + dealerOrPone] = this.round((stats["roundOpponent_Points_" + dealerOrPone] || 0) / (stats["roundOpponent_Played_" + dealerOrPone] || 1), 2);

        //get max points
        stats.round_Points_max = Math.max(roundTotal, stats.round_Points_max || 0);
        stats["round_Points_max_" + level] = Math.max(roundTotal, stats["round_Points_max_" + level] || 0);
        stats["round_Points_max_" + dealerOrPone + "_" + level] = Math.max(roundTotal, stats["round_Points_max_" + dealerOrPone + "_" + level] || 0);
        stats["round_Points_max_" + dealerOrPone] = Math.max(roundTotal, stats["round_Points_max_" + dealerOrPone] || 0);


        //get last points
        stats.round_Points_last = roundTotal || 0;
        stats["round_Points_last_" + level] = roundTotal || 0;
        stats["round_Points_last_" + dealerOrPone + "_" + level] = roundTotal || 0;
        stats["round_Points_last_" + dealerOrPone] = roundTotal || 0;

        //get hands played
        stats.hand_Played = (stats.hand_Played || 0) + 1;
        stats["hand_Played_" + level] = (stats["hand_Played_" + level] || 0) + 1;
        stats["hand_Played_" + dealerOrPone + "_" + level] = (stats["hand_Played_" + dealerOrPone + "_" + level] || 0) + 1;
        stats["hand_Played_" + dealerOrPone] = (stats["hand_Played_" + dealerOrPone] || 0) + 1;

        //get hands Opponent played
        stats.handOpponent_Played = (stats.handOpponent_Played || 0) + 1;
        stats["handOpponent_Played_" + level] = (stats["handOpponent_Played_" + level] || 0) + 1;
        stats["handOpponent_Played_" + dealerOrPone + "_" + level] = (stats["handOpponent_Played_" + dealerOrPone + "_" + level] || 0) + 1;
        stats["handOpponent_Played_" + dealerOrPone] = (stats["handOpponent_Played_" + dealerOrPone] || 0) + 1;

        //get hand points
        stats.hand_Points = (stats.hand_Points || 0) + hand;
        stats["hand_Points_" + level] = (stats["hand_Points_" + level] || 0) + hand;
        stats["hand_Points_" + dealerOrPone + "_" + level] = (stats["hand_Points_" + dealerOrPone + "_" + level] || 0) + hand;
        stats["hand_Points_" + dealerOrPone] = (stats["hand_Points_" + dealerOrPone] || 0) + hand;



        //get hand Opponent points
        stats.handOpponent_Points = (stats.handOpponent_Points || 0) + handOpponent;
        stats["handOpponent_Points_" + level] = (stats["handOpponent_Points_" + level] || 0) + handOpponent;
        stats["handOpponent_Points_" + dealerOrPone + "_" + level] = (stats["handOpponent_Points_" + dealerOrPone + "_" + level] || 0) + handOpponent;
        stats["handOpponent_Points_" + dealerOrPone] = (stats["handOpponent_Points_" + dealerOrPone] || 0) + handOpponent;


        //get avg hand points
        stats.hand_Points_avg = this.round((stats.hand_Points || 0) / (stats.hand_Played || 1), 2);
        stats["hand_Points_avg_" + level] = this.round((stats["hand_Points_" + level] || 0) / (stats["hand_Played_" + level] || 1), 2);
        stats["hand_Points_avg_" + dealerOrPone + "_" + level] = this.round((stats["hand_Points_" + dealerOrPone + "_" + level] || 0) / (stats["hand_Played_" + dealerOrPone + "_" + level] || 1), 2);
        stats["hand_Points_avg_" + dealerOrPone] = this.round((stats["hand_Points_" + dealerOrPone] || 0) / (stats["hand_Played_" + dealerOrPone] || 1), 2);

        //get avg hand Opponent points
        stats.handOpponent_Points_avg = this.round((stats.handOpponent_Points || 0) / (stats.handOpponent_Played || 1), 2);
        stats["handOpponent_Points_avg_" + level] = this.round((stats["handOpponent_Points_" + level] || 0) / (stats["handOpponent_Played_" + level] || 1), 2);
        stats["handOpponent_Points_avg_" + dealerOrPone + "_" + level] = this.round((stats["handOpponent_Points_" + dealerOrPone + "_" + level] || 0) / (stats["handOpponent_Played_" + dealerOrPone + "_" + level] || 1), 2);
        stats["handOpponent_Points_avg_" + dealerOrPone] = this.round((stats["handOpponent_Points_" + dealerOrPone] || 0) / (stats["handOpponent_Played_" + dealerOrPone] || 1), 2);

        //get max points
        stats.hand_Points_max = Math.max(hand, stats.hand_Points_max || 0);
        stats["hand_Points_max_" + level] = Math.max(hand, stats["hand_Points_max_" + level] || 0);
        stats["hand_Points_max_" + dealerOrPone + "_" + level] = Math.max(hand, stats["hand_Points_max_" + dealerOrPone + "_" + level] || 0);
        stats["hand_Points_max_" + dealerOrPone] = Math.max(hand, stats["hand_Points_max_" + dealerOrPone] || 0);


        //get last points
        stats.hand_Points_last = hand || 0;
        stats["hand_Points_last_" + level] = hand || 0;
        stats["hand_Points_last_" + dealerOrPone + "_" + level] = hand || 0;

        //get hand count by score
        stats["hand_PointsCount_all"] = (stats["hand_PointsCount_all"] || 0) + 1;
        stats["hand_PointsCount_all_" + level] = (stats["hand_PointsCount_all_" + level] || 0) + 1;
        stats["hand_PointsCount_all_" + dealerOrPone + "_" + level] = (stats["hand_PointsCount_all_" + dealerOrPone + "_" + level] || 0) + 1;

        stats["hand_PointsCount_" + hand] = (stats["hand_PointsCount_" + hand] || 0) + 1;
        stats["hand_PointsCount_" + hand + "_" + level] = (stats["hand_PointsCount_" + hand + "_" + level] || 0) + 1;
        stats["hand_PointsCount_" + hand + "_" + dealerOrPone + "_" + level] = (stats["hand_PointsCount_" + hand + "_" + dealerOrPone + "_" + level] || 0) + 1;


        //get hand count percent
        stats["hand_PointsCount_percent_" + hand + "_" + level] = (stats["hand_PointsCount_" + hand + "_" + level] / stats["hand_PointsCount_all_" + level]).toFixed(3);

        //calculations for hand count by score
        let totalHandCounts0to7ForLevel = 0;
        let totalHandCounts8to15ForLevel = 0;
        let totalHandCounts16to29ForLevel = 0;
        let totalHandCountsForLevel = 0;
        for (let i = 0; i < 30; i++) {
            if (i <= 7) totalHandCounts0to7ForLevel += stats["hand_PointsCount_" + i + "_" + level] || 0;
            if (i >= 8 && i <= 15) totalHandCounts8to15ForLevel += stats["hand_PointsCount_" + i + "_" + level] || 0;
            if (i >= 16 && i <= 29) totalHandCounts16to29ForLevel += stats["hand_PointsCount_" + i + "_" + level] || 0;
            totalHandCountsForLevel += stats["hand_PointsCount_" + i + "_" + level] || 0; //note this is not matching the total hand count but should stats["hand_PointsCount_all_" + level]
        }
        totalHandCountsForLevel = totalHandCountsForLevel || 1; //avoid divide by zero

        stats["hand_PointsCount_percent_0to7_" + level] = (totalHandCounts0to7ForLevel / totalHandCountsForLevel).toFixed(3);
        stats["hand_PointsCount_percent_8to15_" + level] = (totalHandCounts8to15ForLevel / totalHandCountsForLevel).toFixed(3);
        stats["hand_PointsCount_percent_16to29_" + level] = (totalHandCounts16to29ForLevel / totalHandCountsForLevel).toFixed(3);

        //get hand Opponent count all
        stats["handOpponent_PointsCount_all"] = (stats["handOpponent_PointsCount_all"] || 0) + 1;
        stats["handOpponent_PointsCount_all_" + level] = (stats["handOpponent_PointsCount_all_" + level] || 0) + 1;
        stats["handOpponent_PointsCount_all_" + dealerOrPone + "_" + level] = (stats["handOpponent_PointsCount_all_" + dealerOrPone + "_" + level] || 0) + 1;


        //get hand Opponent count per hand score
        stats["handOpponent_PointsCount_" + handOpponent] = (stats["handOpponent_PointsCount_" + handOpponent] || 0) + 1;
        stats["handOpponent_PointsCount_" + handOpponent + "_" + level] = (stats["handOpponent_PointsCount_" + handOpponent + "_" + level] || 0) + 1;
        stats["handOpponent_PointsCount_" + handOpponent + "_" + dealerOrPone + "_" + level] = (stats["handOpponent_PointsCount_" + handOpponent + "_" + dealerOrPone + "_" + level] || 0) + 1;

        //get hand Opponent count percent
        stats["handOpponent_PointsCount_percent_" + handOpponent + "_" + level] = (stats["handOpponent_PointsCount_" + handOpponent + "_" + level] / stats["handOpponent_PointsCount_all_" + level]).toFixed(3);
        
        //calculations for hand count by score
        let totalHandOpponentCounts0to7ForLevel = 0;
        let totalHandOpponentCounts8to15ForLevel = 0;
        let totalHandOpponentCounts16to29ForLevel = 0;
        let totalHandOpponentCountsForLevel = 0;
        for (let i = 0; i < 30; i++) {
            if (i <= 7) totalHandOpponentCounts0to7ForLevel += stats["handOpponent_PointsCount_" + i + "_" + level] || 0;
            if (i >= 8 && i <= 15) totalHandOpponentCounts8to15ForLevel += stats["handOpponent_PointsCount_" + i + "_" + level] || 0;
            if (i >= 16 && i <= 29) totalHandOpponentCounts16to29ForLevel += stats["handOpponent_PointsCount_" + i + "_" + level] || 0;
            totalHandOpponentCountsForLevel += stats["handOpponent_PointsCount_" + i + "_" + level] || 0;
        }
        totalHandOpponentCountsForLevel = totalHandOpponentCountsForLevel || 1; //avoid divide by zero

        stats["handOpponent_PointsCount_percent_0to7_" + level] = (totalHandOpponentCounts0to7ForLevel / totalHandOpponentCountsForLevel).toFixed(3);
        stats["handOpponent_PointsCount_percent_8to15_" + level] = (totalHandOpponentCounts8to15ForLevel / totalHandOpponentCountsForLevel).toFixed(3);
        stats["handOpponent_PointsCount_percent_16to29_" + level] = (totalHandOpponentCounts16to29ForLevel / totalHandOpponentCountsForLevel).toFixed(3);


        //get hand analyzer score
        stats["hand_Analyzer_Score_last"] = analyzerScore; //todo:get hand analyzer score

        //get count hand analyzer score
        stats["hand_Analyzer_Score_count"] = (stats["hand_Analyzer_Score_count"] || 0) + 1;
        stats["hand_Analyzer_Score_count" + "_" + level] = (stats["hand_Analyzer_Score_count" + "_" + level] || 0) + 1;

        //get avg hand analyzer score
        let avghandanalyzerscore = this.round((((stats["hand_Analyzer_Score_avg"] || 0) * (stats["hand_Analyzer_Score_count"] - 1)) + analyzerScore) / (stats["hand_Analyzer_Score_count"] || 0), 2);
        stats["hand_Analyzer_Score_avg"] = avghandanalyzerscore;

        let avghandanalyzerscoreByLevel = this.round((((stats["hand_Analyzer_Score_avg" + "_" + level] || 0) * (stats["hand_Analyzer_Score_count" + "_" + level] - 1)) + analyzerScore) / (stats["hand_Analyzer_Score_count" + "_" + level] || 0), 2);
        stats["hand_Analyzer_Score_avg" + "_" + level] = avghandanalyzerscoreByLevel;


        //get count hand analyzer Opponent score
        stats["hand_AnalyzerOpponent_Score_count" + "_" + level] = (stats["hand_AnalyzerOpponent_Score_count" + "_" + level] || 0) + 1;

        //get avg hand analyzer rOpponentscore
        let avghandanalyzerscoreByLevelOpponent = this.round((((stats["hand_AnalyzerOpponent_Score_avg" + "_" + level] || 0) * (stats["hand_AnalyzerOpponent_Score_count" + "_" + level] - 1)) + analyzerScoreOpponent) / (stats["hand_AnalyzerOpponent_Score_count" + "_" + level] || 0), 2);
        stats["hand_AnalyzerOpponent_Score_avg" + "_" + level] = avghandanalyzerscoreByLevelOpponent;



        //log occurrence of each card dealt
        if (preHand) {
            for (let card of preHand) {
                stats["cardCount_" + card] = (stats["cardCount_" + card] || 0) + 1;
                let rank = card.substring(0, card.length - 1);
                stats["cardCount_rank_" + rank] = (stats["cardCount_rank_" + rank] || 0) + 1;
                stats["cardCount"] = (stats["cardCount"] || 0) + 1;
                stats["cardCount_rank_" + rank + "_percent"] = (stats["cardCount_rank_" + rank] / stats["cardCount"]).toFixed(5);
            }
        }

        //get last number
        stats.round_Number_last = round || 0;
        stats["round_Number_last_" + level] = round || 0;

        //get pegging_s played
        stats.pegging_Played = (stats.pegging_Played || 0) + 1;
        stats["pegging_Played_" + level] = (stats["pegging_Played_" + level] || 0) + 1;
        stats["pegging_Played_" + dealerOrPone + "_" + level] = (stats["pegging_Played_" + dealerOrPone + "_" + level] || 0) + 1;

        //get pegging_ points
        stats.pegging_Points = (stats.pegging_Points || 0) + play;
        stats["pegging_Points_" + level] = (stats["pegging_Points_" + level] || 0) + play;
        stats["pegging_Points_" + dealerOrPone + "_" + level] = (stats["pegging_Points_" + dealerOrPone + "_" + level] || 0) + play;

        //get avg pegging points
        stats.pegging_Points_avg = this.round((stats.pegging_Points || 0) / (stats.pegging_Played || 1), 2);
        stats["pegging_Points_avg_" + level] = this.round((stats["pegging_Points_" + level] || 0) / (stats["pegging_Played_" + level] || 1), 2);
        stats["pegging_Points_avg_" + dealerOrPone + "_" + level] = this.round((stats["pegging_Points_" + dealerOrPone + "_" + level] || 0) / (stats["pegging_Played_" + dealerOrPone + "_" + level] || 1), 2);

        //get max points
        stats.pegging_Points_max = Math.max(play, stats.pegging_Points_max || 0);
        stats["pegging_Points_max_" + level] = Math.max(play, stats["pegging_Points_max_" + level] || 0);
        stats["pegging_Points_max_" + dealerOrPone + "_" + level] = Math.max(play, stats["pegging_Points_max_" + dealerOrPone + "_" + level] || 0);

        //get last points
        stats.pegging_Points_last = play || 0;
        stats["pegging_Points_last_" + level] = play || 0;


        //get pegging_s played
        stats.peggingOpponent_Played = (stats.peggingOpponent_Played || 0) + 1;
        stats["peggingOpponent_Played_" + level] = (stats["peggingOpponent_Played_" + level] || 0) + 1;
        stats["peggingOpponent_Played_" + dealerOrPone + "_" + level] = (stats["peggingOpponent_Played_" + dealerOrPone + "_" + level] || 0) + 1;

        //get pegging_ points
        stats.peggingOpponent_Points = (stats.peggingOpponent_Points || 0) + playOpponent;
        stats["peggingOpponent_Points_" + level] = (stats["peggingOpponent_Points_" + level] || 0) + playOpponent;
        stats["peggingOpponent_Points_" + dealerOrPone + "_" + level] = (stats["peggingOpponent_Points_" + dealerOrPone + "_" + level] || 0) + playOpponent;

        //get avg pegging points
        stats.peggingOpponent_Points_avg = this.round((stats.peggingOpponent_Points || 0) / (stats.peggingOpponent_Played || 1), 2);
        stats["peggingOpponent_Points_avg_" + level] = this.round((stats["peggingOpponent_Points_" + level] || 0) / (stats["peggingOpponent_Played_" + level] || 1), 2);
        stats["peggingOpponent_Points_avg_" + dealerOrPone + "_" + level] = this.round((stats["peggingOpponent_Points_" + dealerOrPone + "_" + level] || 0) / (stats["peggingOpponent_Played_" + dealerOrPone + "_" + level] || 1), 2);



        if (isDealer) {
            //get cribs played
            stats.crib_Played = (stats.crib_Played || 0) + 1;
            stats["crib_Played_" + level] = (stats["crib_Played_" + level] || 0) + 1;
            //get crib points
            stats.crib_Points = (stats.crib_Points || 0) + crib;
            stats["crib_Points_" + level] = (stats["crib_Points_" + level] || 0) + crib;
            //get avg crib points
            stats.crib_Points_avg = this.round((stats.crib_Points || 0) / (stats.crib_Played || 1), 2);
            stats["crib_Points_avg_" + level] = this.round((stats["crib_Points_" + level] || 0) / (stats["crib_Played_" + level] || 1), 2);
            //get max points
            stats.crib_Points_max = Math.max(crib, stats.crib_Points_max || 0);
            stats["crib_Points_max_" + level] = Math.max(crib, stats["crib_Points_max_" + level] || 0);
            //get last points
            stats.crib_Points_last = crib || 0;
            stats["crib_Points_last_" + level] = crib || 0;
        }
        if (!isDealer) {
            //get cribs played
            stats.cribOpponent_Played = (stats.cribOpponent_Played || 0) + 1;
            stats["cribOpponent_Played_" + level] = (stats["cribOpponent_Played_" + level] || 0) + 1;
            //get crib points
            stats.cribOpponent_Points = (stats.cribOpponent_Points || 0) + cribOpponent;
            stats["cribOpponent_Points_" + level] = (stats["cribOpponent_Points_" + level] || 0) + cribOpponent;
            //get avg crib points
            stats.cribOpponent_Points_avg = this.round((stats.cribOpponent_Points || 0) / (stats.cribOpponent_Played || 1), 2);
            stats["cribOpponent_Points_avg_" + level] = this.round((stats["cribOpponent_Points_" + level] || 0) / (stats["cribOpponent_Played_" + level] || 1), 2);
        }

    }
    updateMatchStats(stats, cribbage, tablePosition) {
        if (!tablePosition) return; //spectator mode

        if (!stats) stats = {};

        tablePosition = tablePosition || "player1";
        let winner = cribbage.matchWinner;
        let isSkunked = cribbage.isSkunked;
        let level = cribbage.level;
        let dealerOrPone = tablePosition == cribbage.dealerStart ? "dealer" : "pone";
        let opponent = tablePosition == "player1" ? cribbage.player2 : cribbage.player1;
        let isOnline = level === "Online";

        if (level === "Online" && opponent && opponent.rank) {
            //get opponet player's rank
            level = opponent.rank;
        }

        //games played
        stats.gamesPlayed = (stats.gamesPlayed || 0) + 1;
        stats["gamesPlayed_" + dealerOrPone] = (stats["gamesPlayed_" + dealerOrPone] || 0) + 1;

        stats["gamesPlayed_" + level] = (stats["gamesPlayed_" + level] || 0) + 1;
        stats["gamesPlayed_" + dealerOrPone + "_" + level] = (stats["gamesPlayed_" + dealerOrPone + "_" + level] || 0) + 1;

        if (isOnline) stats["gamesPlayed_OnlineAll"] = (stats["gamesPlayed_OnlineAll"] || 0) + 1;

        //win
        if (winner === tablePosition) {

            stats.win = (stats.win || 0) + 1;
            stats["win_" + dealerOrPone] = (stats["win_" + dealerOrPone] || 0) + 1;

            stats["win_" + level] = (stats["win_" + level] || 0) + 1;
            stats["win_" + dealerOrPone + "_" + level] = (stats["win_" + dealerOrPone + "_" + level] || 0) + 1;

            stats.win_streak = (stats.win_streak || 0) + 1;
            stats["win_streak_" + level] = (stats["win_streak_" + level] || 0) + 1;
            stats["win_streak_" + dealerOrPone + "_" + level] = stats["win_streak_" + level];

            stats.win_streak_max = Math.max(stats.win_streak_max || 0, stats.win_streak || 0);
            stats["win_streak_max_" + level] = Math.max(stats["win_streak_max_" + level] || 0, stats["win_streak_" + level] || 0);

            stats.loss_streak = 0;
            stats["loss_streak_" + level] = 0;

            if (isSkunked) stats["skunked"] = (stats["skunked"] || 0) + 1;
            if (isSkunked) stats["skunked_" + level] = (stats["skunked_" + level] || 0) + 1;

            if (isOnline) stats["win_OnlineAll"] = (stats["win_OnlineAll"] || 0) + 1;

        }
        //lose
        if (winner !== tablePosition) {

            stats.loss = (stats.loss || 0) + 1;
            stats["loss_" + dealerOrPone] = (stats["loss_" + dealerOrPone] || 0) + 1;

            stats["loss_" + level] = (stats["loss_" + level] || 0) + 1;
            stats["loss_" + dealerOrPone + "_" + level] = (stats["loss_" + dealerOrPone + "_" + level] || 0) + 1;

            stats.win_streak = 0;
            stats["win_streak_" + level] = 0;

            stats.loss_streak_max = Math.max(stats.loss_streak_max || 0, stats.loss_streak || 0);
            stats["loss_streak_max_" + level] = Math.max(stats["loss_streak_max_" + level] || 0, stats["loss_streak_" + level] || 0);


            stats.loss_streak = (stats.loss_streak || 0) + 1;
            stats["loss_streak_" + level] = (stats["loss_streak_" + level] || 0) + 1;

            if (isSkunked) stats["skunkedgot"] = (stats["skunkedgot"] || 0) + 1;
            if (isSkunked) stats["skunkedgot_" + level] = (stats["skunkedgot_" + level] || 0) + 1;

            if (isOnline) stats["loss_OnlineAll"] = (stats["loss_OnlineAll"] || 0) + 1;
        }
        //calculations
        stats.win_rate = ((stats.win || 0) / (stats.gamesPlayed || 1)).toFixed(2);
        stats["win_rate_" + level] = ((stats["win_" + level] || 0) / (stats["gamesPlayed_" + level] || 1)).toFixed(2);

        stats["win_rate_dealer_" + level] = ((stats["win_dealer_" + level] || 0) / (stats["gamesPlayed_dealer_" + level] || 1)).toFixed(2);
        stats["win_rate_pone_" + level] = ((stats["win_pone_" + level] || 0) / (stats["gamesPlayed_pone_" + level] || 1)).toFixed(2);



        //get friends stats
        if (opponent && stats.friends) {
            let friend = stats.friends.find(f => f.id && opponent.id && f.id === opponent.id);
            if (!friend) friend = stats.friends.find(f => f.name && opponent.name && f.name === opponent.name);
            if (friend) {
                //games played
                friend.gamesPlayed = (friend.gamesPlayed || 0) + 1;

                //win
                if (winner === tablePosition) {
                    friend.win = (friend.win || 0) + 1;
                    friend.win_streak = (friend.win_streak || 0) + 1;
                    friend.win_streak_max = Math.max(friend.win_streak_max || 0, friend.win_streak || 0);
                    friend.loss_streak = 0;
                    if (isSkunked) friend.skunked = (friend.skunked || 0) + 1;
                }
                //lose
                if (winner !== tablePosition) {
                    friend.loss = (friend.loss || 0) + 1;
                    friend.win_streak = 0;
                    friend.loss_streak = (friend.loss_streak || 0) + 1;
                }
                //calculations
                friend.win_rate = ((friend.win || 0) / (friend.gamesPlayed || 1)).toFixed(2);
            }
        }

    }
    round(number, precision) {
        var shift = function (number, precision, reverseShift) {
            if (reverseShift) {
                precision = -precision;
            }
            var numArray = ("" + number).split("e");
            return +(numArray[0] + "e" + (numArray[1] ? (+numArray[1] + precision) : precision));
        };
        return shift(Math.round(shift(number, precision, false)), precision, true);
    }



}